export default __webpack_public_path__ + "static/media/arcgis-data-health-checks.ca1e9f98.svg";